import { CustomerAddress } from "../../../@types/Billing/Customer";
import { api } from "../../api";

export default async function create(
  customerData: CustomerAddress
): Promise<number> {
  try {
    const { status } = await api.post("/billing/customer", customerData);

    return status;
  } catch (err) {
    console.log(err);
    return 500;
  }
}
